module.exports = __webpack_public_path__ + "media/audio12.f2876097.wav";